class Address {
	constructor(obj) {
		if (obj) {
			Object.assign(this, obj)
			return
		}

		this.id = Math.floor(Math.random() * 1000)
		this.pincode = ''
		this.complete_address = ''
		this.city = ''
		this.country = 'India'
		this.district = ''
		this.division = ''
		this.name_tag = ''
		this.state = ''
		this.latitude = 0
		this.longitude = 0
		this.address_id = null
	}

	static toString = (address) => {
		return (
			(address.complete_address ? address.complete_address + ', ' : '') +
			(address.city ? address.city + ', ' : '') +
			(address.district ? address.district + ', ' : '') +
			(address.division ? address.division + ', ' : '') +
			(address.state ? address.state + ', ' : '') +
			(address.pincode ? ' (' + address.pincode + ') - ' : '') +
			(address.country || '')
		)
	}

	getCityState = () => {
		return this.city + ', ' + this.state
	}

	updatePincode(pincode) {
		this.pincode = pincode
		return this
	}

	getCompleteAddress() {
		// call this function when complete address is not present
		return `${
			(this.city ? this.city + ', ' : '') +
			(this.district ? this.district + ', ' : '') +
			(this.division ? this.division + ', ' : '') +
			(this.state ? this.state + ', ' : '') +
			(this.pincode ? ' (' + this.pincode + ') - ' : '') +
			(this.country || '')
		}`
	}
}

export default Address
